import type { ConnectorOAuthConfig } from "../types";

export function dcrOAuth(options: {
  serverUrl: string;
  issuer: string;
  authorizationEndpoint: string;
  tokenEndpoint: string;
  resource?: string;
  scopes: readonly string[];
}): ConnectorOAuthConfig {
  return {
    grantType: () => "authorization_code",
    clientCredentialsFrom: "dcr",
    discoverFrom: () => options.serverUrl,
    issuer: (cfg) => cfg.issuer ?? options.issuer,
    authorizationEndpoint: (cfg) =>
      cfg.authorizeUrl ?? options.authorizationEndpoint,
    tokenEndpoint: (cfg) => cfg.tokenUrl ?? options.tokenEndpoint,
    tokenEndpointAuthMethod: (_configuration, { hasSecret }) =>
      hasSecret ? "client_secret_post" : "none",
    pkce: () => true,
    scopes: () => [...options.scopes],
    ...(options.resource && {
      resource: (cfg) => cfg.resource ?? options.resource!,
    }),
  };
}
